












import Vue from 'vue';
import { Component, Prop, Ref, Watch } from 'vue-property-decorator';

@Component<CFileInput>({})
export default class CFileInput extends Vue {
  @Prop({ type: File })
  value: File;

  @Ref('fileInput')
  fileInput!: HTMLInputElement;

  filenameAttachment = '';

  changeFile(e) {
    this.filenameAttachment = e.target.files[0].name;
    this.$emit('input', e.target.files[0]);
  }

  @Watch('value')
  async onPropertyChanged(newValue) {
    if (newValue === null) {
      this.filenameAttachment = '';
    }
  }
}
